export enum ITemplateType {
  email = "EMAIL",
  page = "PAGE"
}

export default interface ITemplate {
  name?: string,
  title: string,
  description: string,
  category?: string,
  code?: string,
  type: ITemplateType,
  seeded?: boolean,
  content: string,
  lastActivity?: any,
  uid: string
}